import React from 'react';
import { Link } from 'react-router-dom';
import './Navbar.css';

import twitterIcon from '../assets/social/header-twitter.svg';
import discordIcon from '../assets/social/header-discord.svg';
import telegramIcon from '../assets/social/header-telegram.svg';
import instagramIcon from '../assets/social/Instagram.webp';
import mediumIcon from '../assets/social/Medium.webp';
import facebookIcon from '../assets/social/Facebook.webp';
import logo from '../assets/logo/logo.webp';

function Navbar() {
  return (
    <nav className="navbar-wood">
      <div className="navbar-left">
        <Link to="/" className="navbar-brand">
          <img src={logo} alt="Logo" className="navbar-logo-img" />
          <span className="navbar-logo-text">Ranchers Land</span>
        </Link>
      </div>

      <ul className="navbar-links">
        <li><Link to="/">Home</Link></li>
        <li><Link to="/market">Market</Link></li>
        <li>
          <a href="https://ranchers-land.gitbook.io/ranchersland" target="_blank" rel="noopener noreferrer">
            Whitepaper
          </a>
        </li>
        <li><Link to="/calculator">Calculator</Link></li>
        <li>
          <a href="https://ranchers-land.gitbook.io/ranchersland/f.a.q." target="_blank" rel="noopener noreferrer">
            FAQs
          </a>
        </li>

        {/*
        <li>
          <a
            href="https://neftyblocks.com/collection/ranchersland/drops/"
            target="_blank"
            rel="noopener noreferrer"
            className="navbar-link-drops"
          >
            Drops
          </a>
        </li>
        */}
      </ul>

      <div className="navbar-icons">
        <a href="https://twitter.com/ranchersland" target="_blank" rel="noopener noreferrer">
          <img src={twitterIcon} alt="Twitter" />
        </a>
        <a href="https://discord.gg/Rqsr8YpQuh" target="_blank" rel="noopener noreferrer">
          <img src={discordIcon} alt="Discord" />
        </a>
        <a href="https://t.me/ranchersland" target="_blank" rel="noopener noreferrer">
          <img src={telegramIcon} alt="Telegram" />
        </a>
        <a href="https://www.instagram.com/ranchers.land/" target="_blank" rel="noopener noreferrer">
          <img src={instagramIcon} alt="Instagram" />
        </a>
        <a href="https://medium.com/@ranchersland" target="_blank" rel="noopener noreferrer">
          <img src={mediumIcon} alt="Medium" />
        </a>
        <a href="https://web.facebook.com/ranchers.land/" target="_blank" rel="noopener noreferrer">
          <img src={facebookIcon} alt="Facebook" />
        </a>
      </div>

      <div className="play-button-wrapper">
        <Link to="/play" className="play-button">Play & Earn</Link>
      </div>
    </nav>
  );
}

export default Navbar;
